(function() {
  if (document.querySelector('.video-wrapper video') != null) {

    const videoIcons = document.querySelectorAll('.video-icon');
    videoIcons.forEach(videoIcon => {
      videoIcon.addEventListener('click', () => {
        videoIcon.previousElementSibling.setAttribute('controls', 'controls');
        videoIcon.previousElementSibling.play();
        videoIcon.remove();
      });
    });

    const buttons = document.querySelectorAll('.video-icon button');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        button.parentNode.previousElementSibling.play();
        button.parentNode.previousElementSibling.setAttribute('controls', 'controls');
        button.parentNode.remove();
      })
    })
  }
})();
